export const flexParentPropsObj = {
  display: {
    propertyName: 'display',
    propertyValue: ['block', 'flex'],
    defaultPropertyValue: 'block'
  },
  flexDirection: {
    propertyName: 'flex-direction',
    propertyValue: ['row', 'row-reverse', 'column', 'column-reverse'],
    defaultPropertyValue: 'row'
  },
  flexWrap: {
    propertyName: 'flex-wrap',
    propertyValue: [ 'nowrap', 'wrap', 'wrap-reverse'],
    defaultPropertyValue: 'nowrap'
  },
  justifyContent: {
    propertyName: 'justify-content',
    propertyValue: [ 'flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
    defaultPropertyValue: 'flex-start'
  },
  alignItems: {
    propertyName: 'align-items',
    propertyValue: [ 'stretch', 'flex-start', 'flex-end', 'center', 'baseline'],
    defaultPropertyValue: 'stretch'
  },
  alignContent: {
    propertyName: 'align-content',
    propertyValue: [ 'stretch', 'flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
    defaultPropertyValue: 'stretch'
  }
};

export const flexChildPropsObj = {
  alignSelf: {
    propertyName: 'align-self',
    propertyValue: [ 'stretch', 'flex-start', 'flex-end', 'center', 'baseline'],
    defaultPropertyValue: 'stretch'
  }
};